export enum BudgetAllocationStatus {
	New = "New",
	Draft = "Draft",
	SubmittedForDepartmentalAllocation = "Submitted For Departmental Allocation",
	SubmittedForConsolidation = "Submitted For Consolidation",
	SubmittedForApproval = "Submitted For Approval",
	SubmittedForDOAApproval = "Submitted For DOA Approval",
	SubmittedForERPIntegration = "Submitted For ERP Integration",
	Integrated = "Integrated",
	Active = "Active",
	Deleted = "Deleted",
	Rejected = "Rejected",
}

export enum BudgetStateName {
	Surplus = "Surplus",
	Balanced = "Balanced",
	Deficit = "Deficit",
}

export enum BudgetType {
	Revenue = 1,
	OpEx = 2,
	CapEx = 3,
}

export enum BudgetTypeName {
	Revenue = "REVENUE",
	OpEx = "OPEX",
	CapEx = "CAPEX",
}

export enum FinancialYearStatus {
	Open = 1,
	Closed = 2,
	Budgeting = 3,
	Future = 4,
}

export enum BudgetAllocationTabName {
	Allocation = "Allocation",
	MasterBudget = "MasterBudget",
	ChangeOrder = "ChangeOrder",
	Requisition = "Requisition",
	Bid = "Bid",
	UnpaidExpenses = "UnpaidExpenses",
	PaidExpenses = "PaidExpenses",
	Default = "",
}

export enum BudgetAllocationTabIndex {
	Allocation = 0,
	MasterBudget = 1,
	ChangeOrder = 2,
	Requisition = 3,
	Bid = 4,
	UnpaidExpenses = 5,
	PaidExpenses = 6,
}

export enum BudgetAllocationStepHistoryStatus {
	Completed = "Completed",
	Ready = "Ready",
	Pending = "Pending",
	Recalled = "Recalled",
	ChangeRequested = "Change Requested",
	Rejected = "Rejected",
	Deleted = "Deleted",
	Delegated = "Delegated",
	Escalated = "Escalated",
	Cancelled = "Cancelled",
}

export enum BudgetAllocationStepHistoryStatusId {
	Completed = 1,
	Ready = 2,
	Pending = 3,
	Recalled = 4,
	ChangeRequested = 5,
	Rejected = 6,
	Deleted = 7,
	Delegated = 8,
	Escalated = 9,
	Cancelled = 10,
}

export enum BudgetingStage {
	FinanceAllocation = 1,
	DepartmentAllocation = 2,
	FinanceBudgetConsolidation = 3,
	BudgetApproval = 4,
	DOAApproval = 5,
	ERPIntegration = 6,
}

export enum BudgetingStageName {
	FinanceAllocation = "Finance Allocation",
	DepartmentAllocation = "Department Allocation",
	FinanceBudgetConsolidation = "Finance Budget Consolidation",
	BudgetApproval = "Budget Approval",
	DOAApproval = "DOA Approval",
	ERPIntegration = "ERP Integration",
}

export enum BudgetModulePhase {
	FinanceAllocation = 6,
	DepartmentalAllocation = 7,
	FinanceConsolidation = 8,
	Approval = 9,
	DOA = 10,
}

export enum ChangeOrderStatus {
	Saved = "Saved",
	Approved = "Approved",
	Rejected = "Rejected",
	SubmittedForFinanceApproval = "Submitted for Finance Approval",
}

export enum ChangeOrderAdjustmentStatus {
	Draft = "Draft",
	Approved = "Approved",
	Rejected = "Rejected",
}

export enum ChangeOrderTransferStatus {
	Draft = "Draft",
	Approved = "Approved",
	Rejected = "Rejected",
}

export enum RequisitionLineActionType {
	Adjustment = "Adjustment",
	Transfer = "Transfer",
}

export enum RequisitionLineConfirmationType {
	Approve = "Approve",
	Reject = "Reject",
}

export enum RequisitionLineDetailBudgetChangeOrderStatusId {
	Saved = 1,
	Approved = 2,
	Rejected = 3,
	SubmittedForFinanceApproval = 4,
	Cancelled = 5,
	New = 6,
}

export enum BudgetAllocationLineStatusId {
	Draft = 1,
	PreAllocation = 2,
	Approved = 3,
	SubmittedForDepartmentalAllocation = 4,
	Deleted = 5,
	ChangeRequested = 6,
	ChangeRequestCompleted = 7,
	ChangeRequestedForDepartmentAllocation = 8,
	Rejected = 9,
	ChangeRequestedForFinanceConsolidation = 10,
}

export enum BudgetAllocationLineDetailStatusId {
	Draft = 1,
	PreAllocation = 2,
	Approved = 3,
	SubmittedForConsolidation = 4,
	Deleted = 5,
	ChangeRequested = 6,
	ChangeRequestCompleted = 7,
}

export enum BudgetAllocationLineDetailStatus {
	Draft = "Draft",
	PreAllocation = "Pre-Allocation",
	Approved = "Approved",
	SubmittedForConsolidation = "Submitted For Consolidation",
	Deleted = "Deleted",
	ChangeRequested = "Change Requested",
	ChangeRequestCompleted = "Change Request Completed",
}

// Required for Budget Allocation Email Confirmation type
export enum BudgetAllocationConfirmationType {
	Rejection = "reject",
	Approve = "approve",
	TaskCompletion = "task-complete",
	ChangeRequest = "change-request",
}

// Required for Budget Allocation Email Action type
export enum BudgetAllocationActionType {
	Edit = "edit",
}

export enum AdjustmentType {
	Increase = 1,
	Decrease = 2,
}

export enum FinAllocationAdjustmentStatus {
	Draft = 1,
	Approved = 2,
	Rejected = 3,
	Deleted = 4,
	ChangeRequested = 5,
	ChangeRequestCompleted = 6,
}

export enum DeptAllocationAdjustmentStatus {
	Draft = 1,
	Approved = 2,
	Rejected = 3,
	Deleted = 4,
	ChangeRequested = 5,
	ChangeRequestCompleted = 6,
}

export enum TransferFrom {
	Source = 1,
	Receive = 2,
}

export enum BudgetFlyInActionType {
	Adjustment = "Adjustment",
	Transfer = "Transfer",
}

export enum FinTransferStatus {
	Draft = 1,
	Approved = 2,
	Rejected = 3,
	Deleted = 4,
	ChangeRequested = 5,
	ChangeRequestCompleted = 6,
}

export enum DeptTransferStatus {
	Draft = 1,
	Approved = 2,
	Rejected = 3,
	Deleted = 4,
	ChangeRequested = 5,
	ChangeRequestCompleted = 6,
}

export enum DeptTransferStatusName {
	Draft = "Draft",
	Approved = "Approved",
	Rejected = "Rejected",
	Deleted = "Deleted",
	ChangeRequested = "Change Requested",
	ChangeRequestCompleted = "Change Request Completed",
}

export enum FinTransferStatusName {
	Draft = "Draft",
	Approved = "Approved",
	Rejected = "Rejected",
	Deleted = "Deleted",
	ChangeRequested = "Change Requested",
	ChangeRequestCompleted = "Change Request Completed",
}

export enum BudgetApprovalStatus {
	Balanced = 1,
	Surplus = 2,
	Deficit = 3,
}

export enum BudgetApprovalStatusName {
	Balanced = "Balanced",
	Surplus = "Surplus",
	Deficit = "Deficit",
}

export enum BudgetWorkflowStepType {
	Approval = 1,
	Task = 2,
}

export enum BudgetConfirmationType {
	Approve = "Approve",
	TaskComplete = "Task Complete",
	Reject = "Reject",
	ChangeRequest = "Change Request",
}
